import { SITE_STATUS } from '../lib/status';

const ORDER = ['installed', 'inspected_ok', 'repaired', 'replaced', 'repair_pending', 'damaged', 'not_installed'];

export function StatusBar({ counts = {}, total = 0, className = '' }) {
  const segs = ORDER.filter((k) => counts[k]);
  return (
    <div className={className}>
      <div className="flex h-2.5 w-full overflow-hidden rounded-full bg-secondary">
        {total === 0 ? <div className="w-full bg-secondary" /> : segs.map((k) => (
          <div key={k} title={`${SITE_STATUS[k].label}: ${counts[k]}`} style={{ width: `${(counts[k] / total) * 100}%`, background: SITE_STATUS[k].dot }} />
        ))}
      </div>
    </div>
  );
}

export function StatChips({ counts = {} }) {
  const segs = ORDER.filter((k) => counts[k]);
  if (!segs.length) return <p className="text-xs text-muted-foreground">No sites yet.</p>;
  return (
    <div className="flex flex-wrap gap-1.5">
      {segs.map((k) => (
        <span key={k} className="flex items-center gap-1.5 rounded-full border border-border bg-card px-2 py-0.5 text-[11px]">
          <span className="h-2 w-2 rounded-full" style={{ background: SITE_STATUS[k].dot }} /> {SITE_STATUS[k].label}: <b>{counts[k]}</b>
        </span>
      ))}
    </div>
  );
}

export function StatCard({ label, value, sub, icon: Icon, tone = 'text-foreground', testid }) {
  return (
    <div data-testid={testid} className="rounded-xl border border-border bg-card p-4">
      <div className="flex items-center justify-between">
        <p className="overline text-muted-foreground">{label}</p>
        {Icon && <Icon className={`h-4 w-4 ${tone}`} />}
      </div>
      <p className={`mt-1.5 font-head text-3xl font-extrabold ${tone}`}>{value}</p>
      {sub && <p className="mt-0.5 text-xs text-muted-foreground">{sub}</p>}
    </div>
  );
}

export function damageTone(pct) {
  if (pct >= 20) return 'text-rose-400';
  if (pct >= 8) return 'text-amber-400';
  return 'text-emerald-400';
}

export function DamageGauge({ stats }) {
  const pct = stats?.damage_pct || 0;
  const tone = damageTone(pct);
  const r = 34, c = 2 * Math.PI * r;
  const off = c - (Math.min(pct, 100) / 100) * c;
  const stroke = pct >= 20 ? '#ef4444' : pct >= 8 ? '#f59e0b' : '#10b981';
  return (
    <div className="flex items-center gap-4">
      <svg width="88" height="88" viewBox="0 0 88 88" className="-rotate-90">
        <circle cx="44" cy="44" r={r} fill="none" stroke="hsl(var(--secondary))" strokeWidth="9" />
        <circle cx="44" cy="44" r={r} fill="none" stroke={stroke} strokeWidth="9" strokeLinecap="round" strokeDasharray={c} strokeDashoffset={off} />
      </svg>
      <div>
        <p className={`font-head text-3xl font-extrabold ${tone}`}>{pct}%</p>
        <p className="overline text-muted-foreground">Damage Rate</p>
        <p className="mt-1 text-xs text-muted-foreground">Health score <b className={tone}>{stats?.health}%</b></p>
      </div>
    </div>
  );
}
